import React from "react";

//
import BuySellAlerts from "../../assets/img/auth-images/Buy-Sell-Alerts.png";
import VolumeChange from "../../assets/img/auth-images/Volume-change.png";
import AlertsHistory from "../../assets/img/auth-images/Alerts-History.png";
import TrendChange from "../../assets/img/auth-images/Trend-change.png";

import SwiperCore, { Pagination, Scrollbar, A11y, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.scss";
import "swiper/components/pagination/pagination.scss";
SwiperCore.use([Pagination, Scrollbar, A11y, Autoplay]);

function Slider() {
  let items = [
    {
      image: BuySellAlerts,
      title: "Buy/Sell Alerts",
      subject:
        "Invalert’s unique proprietary AI-based algorithms perform speedy analysis of large, complex amounts of data involving past and current trading patterns of currently available crypto coins.",
    },
    {
      image: VolumeChange,
      title: "Volume Change",
      subject:
        "Invalert’s unique proprietary AI-based algorithms perform speedy analysis of large, complex amounts of data. involving past and current trading patterns of currently available crypto coins.",
    },
    {
      image: TrendChange,
      title: "Up & Down Trends",
      subject:
        "Invalert’s unique proprietary AI-based algorithms perform speedy analysis of large, complex amounts of data involving past and current trading patterns of currently available crypto coins.",
    },
    {
      image: AlertsHistory,
      title: "Alerts History",
      subject:
        "We share all historical alerts for FREE. Before starting your subscription, sign up and check all previous alerts. You will enjoy full access once you have subscribed to one of our paid members.",
    },
  ];

  const pagination = {
    clickable: true,
  };
  return (
    <Swiper
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
      }}
      slidesPerView={1}
      spaceBetween={10}
      modules={[Pagination, Scrollbar, A11y]}
      pagination={pagination}
    >
      {items.map((item, index) => (
        <SwiperSlide key={index}>
          <div className="d-flex flex-column align-items-center ">
            <img src={item.image} alt="image" />

            <h5>{item.title}</h5>

            <small className="text-center">{item.subject}</small>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}

export default Slider;
